import {
  createNewEndorsement,
  updateEndorsement,
} from "@/graphql/mutations";
import { listEndorsements } from "@/graphql/queries";
import { GraphQLQuery } from "@aws-amplify/api";
import { useQuery } from "@tanstack/react-query";
import { API, graphqlOperation } from "aws-amplify";

type STATUS = "APPROVED" | "PENDING" | "REJECTED";

interface createEndorsePayload {
  description: string;
  endorsementAssignedToId: string;
  endorsementCreatedById: string;
  status: string;
}

interface CreateEndorsementMutation {
  createEndorsement: createEndorsePayload;
}

interface requestEndorsePayload {
  description: string;
  userID: string;
}

interface RequestEndorsementMutation {
  requestEndorsement: requestEndorsePayload;
}

export const requestCreateEndorse = async (payload: createEndorsePayload) => {
  await API.graphql<GraphQLQuery<CreateEndorsementMutation>>({
    query: createNewEndorsement,
    variables: {
      input: {
        description: payload.description,
        endorsementAssignedToId: payload.endorsementAssignedToId,
        endorsementCreatedById: payload.endorsementCreatedById,
        status: payload.status,
      },
    },
  });
};

export const fetchListOfEndorsements = async (status?: STATUS, assignedTo?: string) => {
  const response: any = await API.graphql(
    graphqlOperation(listEndorsements, {
      filter: {
        status: {
          eq: status,
        },
        endorsementAssignedToId: { eq: assignedTo },
      },
    }),
  );
  const records: any[] = response?.data?.listEndorsements?.items ?? [];

  return records;
};

export const requestEndorse = async (payload: requestEndorsePayload) => {
  await API.graphql<GraphQLQuery<RequestEndorsementMutation>>({
    query: createNewEndorsement,
    variables: {
      description: payload.description,
      userID: payload.userID,
    },
  });
};

export const useGetEndorsements = (
  status?: STATUS,
  assignedTo?: string,
  automaticRefetching: boolean = false,
) => {
  return useQuery({
    queryKey: [`KEY_GET_ENDORSEMENTS-${status}`],
    queryFn: () => fetchListOfEndorsements(status, assignedTo),
    enabled: automaticRefetching,
  });
};

export const updateEndorse = async (id: string, status: string, _version: number) => {
  const res = await API.graphql<GraphQLQuery<RequestEndorsementMutation>>({
    query: updateEndorsement,
    variables: {
      input: {
        id,
        status,
        _version,
      },
    },
  });

  return res;
};
